import React from 'react';
import PropTypes from 'prop-types';

// Components
import { MapLayerWrapper as Layer } from '../../Common';

// Constants
import { LAYERS } from '../Constants';

// Theme & Utils
import { colors } from '../../../Core/Theme';
import { createHash } from '../../../Core/Utils';

// Layer properties
const fillProperties = {
  id: `${LAYERS.UNASSIGNED_OFFICE}-lines`,
  type: 'line',
  source: 'features',
  paint: {
    'line-color': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      colors.dark,
      colors.gray,
    ],
    'line-width': 5,
  },
};
const lineProperties = {
  id: LAYERS.UNASSIGNED_OFFICE,
  type: 'fill',
  source: 'features',
  paint: {
    'fill-color': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      colors.light,
      colors.white,
    ],
  },
};

// Legend
const legend = {
  key: LAYERS.UNASSIGNED_OFFICE,
  style: {
    backgroundColor: colors.white,
    borderColor: colors.dark,
    borderWidth: 2,
    borderStyle: 'solid',
  },
  labelKey: 'deskFloorPlan.legend.unassignedOffice',
};

const UnassignedOffice = props => {
  const { offices } = props;
  return (
    <Layer
      key={`${LAYERS.UNASSIGNED_OFFICE}-${createHash(offices)}`}
      properties={[fillProperties, lineProperties]}
      filter={['in', ['get', 'id'], ['literal', offices]]}
      {...props}
    />
  );
};

UnassignedOffice.defaultProps = {
  offices: [],
};
UnassignedOffice.propTypes = {
  offices: PropTypes.arrayOf(PropTypes.string),
};

export { legend };
export default React.memo(UnassignedOffice);
